import { Error } from '../components/Error';

export const NotFound = () => (
  <Error title='404 Not Found'>We're sorry, the page you requested could not be found.</Error>
);
